/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import Vue from "vue";
const momentTz = require('moment-timezone')

const lib = {};

lib.initialState = () => {
  return {
    token: null,
    language: 'en',
    theme: "",
    theme_dark: false,
    autoReload: true,
    instantRefresh: false,
    mailResendTime: null,
    currentPassword: "",
    isPasswordUpdateSkip: true,
    passwordChangeStatus: "",
    passwordResetDiff: null,
    mapRedirectPlant: false,
    mapRedirectBlock: false,
    isAlertRedirected: false,
    showHomeDB: true,
    miniNav: true,
    logo: {},
    static_info: {},
    sld_data: {},
    plantConfig: [],
    selectedBlockId: 1,
    reloadTimer: 60000,
    lastCallTime: null,
    selectedAlert: null,
    activePlant: {},
    isFloatingButton: {},
    isBanner: {},
    selectedComponent: "",
    notifications: [],
    totalNotifications: 0,
    inverter_block_gen: null,
    plantData: {},
    userData: {
      lastNotificationViewed: 1588993554,
    },
    totalGeneration: 0,
    plantTotalGeneration: 0,
    totalPlantCount: 0,
    totalExpiredPlantCount: 0,
    totalRenewPlantCount: 0,
    aboutToExpireCount: 0,
    activeFilterOption: {},
    updateTheDB: true,
    alteredFilterValues: {},
    filter: {},
    headerCards: {
      "custom-report": false,
      tracker: false,
      alert: false,
      plantAnalytics: false,
      inverterRanking: false,
      downTimeAnalysis: false,
      forecast: false,
      liveDash: true,
    },
    filterDisabled: {
      liveDash: true,
    },
    showSnackBar: false,
    snackBar: {
      icon: "",
      header: "",
      message: "",
    },
    showDialog: false,
    dialog: {
      ref: "",
      icon: "",
      header: "",
      contents: [],
      actions: [],
    },
    isProgress: false,
    isKpi: false,
    totalPlantPr: 0,
    moduleBrand: {},
    defaultDate: '',
  };
};

lib.SET_ACTIVE_FILTER = (state, payload) => {
  for (const [key, value] of Object.entries(payload)) {
    Vue.set(state.activeFilterOption, key, value);
  }
};

lib.RESET_ACTIVE_FILTER = (state) => {
  state.updateTheDB = true;
  state.activeFilterOption = {};
};

lib.SET_DEFAULT_DATE = (state, payload) => {
  state.defaultDate = payload;
};

lib.SET_UPDATE_FILTER_DB = (state, payload) => {
  state.updateTheDB = payload;
};

lib.SET_USER_DATA = (state, data) => {
  state.userData = data;
};

lib.SET_RELOAD_TIMER = (state, reloadTimer) => {
  state.reloadTimer *= reloadTimer;
};

lib.SET_PLANT_TOTAL_GENERATION = (state, plantTotalGeneration) => {
  state.plantTotalGeneration = plantTotalGeneration;
};

lib.SET_TOTAL_GENERATION = (state, generation) => {
  state.totalGeneration = generation;
};

lib.SET_JWT_TOKEN = (state, jwtToken) => {
  state.token = jwtToken;
};

lib.SET_LANGUAGE = (state, language) => {
  state.language = language;
};

lib.SET_THEME = (state, isDark) => {
  state.theme_dark = isDark;
};

lib.SET_THEME_VALUE = (state, theme) => {
  state.theme = theme;
};

lib.SET_MAP_REDIRECT_PLANT = (state, isRedirect) => {
  state.mapRedirectPlant = isRedirect;
};

lib.SET_MAP_REDIRECT_BLOCK = (state, isRedirect) => {
  state.mapRedirectBlock = isRedirect;
};

lib.SET_AUTO_RELOAD = (state, autoReload) => {
  state.autoReload = autoReload;
};

lib.SET_LAST_CALL_TIME = (state, lastCallTime) => {
  const tz = state.plantData[state.activePlant.plant_id]['timezone']
  state.lastCallTime = momentTz(lastCallTime).tz(tz).format('MM-DD-YYYY H:mm:ss');
};

lib.SET_INSTANT_REFRESH = (state, instantRefresh) => {
  state.instantRefresh = instantRefresh;
};

lib.SET_MAIL_RESEND_TIME = (state, mailResendTime) => {
  state.mailResendTime = mailResendTime;
};

lib.SET_CURRENT_PASSWORD = (state, currentPassword) => {
  state.currentPassword = currentPassword;
};

lib.SET_PASSWORD_CHANGE_STATUS = (state, passwordChangeStatus) => {
  state.passwordChangeStatus = passwordChangeStatus;
};

lib.SET_PASSWORD_UPDATE_SKIP = (state, isPasswordUpdateSkip) => {
  state.isPasswordUpdateSkip = isPasswordUpdateSkip;
};

lib.SET_PASSWORD_RESET_DIFF = (state, diff) => {
  state.passwordResetDiff = diff;
};

lib.RESET_STATE = (state) => {
  const initial = lib.initialState();
  Object.assign(state, initial);
};

lib.SET_SELECTED_PLANT_ID = (state, plantId) => {
  state.activePlant = state.plantData[plantId];
};

lib.SET_SELECTED_BLOCK_ID = (state, blockId) => {
  state.selectedBlockId = blockId;
};

lib.SET_IS_ALERT_REDIRECTED = (state, status) => {
  state.isAlertRedirected = status;
};

lib.SET_SELECTED_ALERT = (state, alert) => {
  state.selectedAlert = alert;
};

lib.SET_INVERTER_GRAPH_ENERGY = (state, gen) => {
  state.inverter_block_gen = gen;
};

lib.SET_ACTIVE_PLANT = (state, payload) => {
  state.activePlant = payload;
};

lib.SET_SHOW_HOME_DB = (state, payload) => {
  state.showHomeDB = payload;
};

lib.SET_SELECTED_COMPONENT_MENU = (state, payload) => {
  state.selectedComponent = payload;
};

lib.SET_NOTIFICATION_DATA = (state, payload) => {
  state.notifications = payload;
};

lib.SET_NOTIFICATION_COUNT = (state, payload) => {
  state.totalNotifications = payload;
};

lib.APPEND_NEW_NOTIFICATION = (state, payload) => {
  state.notifications.unshift(payload);
};

lib.SET_MODULE_BRAND = (state, payload) => {
  state.moduleBrand[payload.plant_id] = payload.brand;
};

lib.SET_TOTAL_PR = (state, payload) => {
  state.totalPlantPr = payload;
};
lib.APPEND_NOTIFICATION = (state, payload) => {
  if (payload instanceof Array) {
    state.notifications = state.notifications.concat(...payload);
  } else {
    Vue.set(state.notifications, 0, payload);
  }
};

lib.SET_TOTAL_PLANT_COUNT = (state, data) => {
  state.totalPlantCount = data;
};

lib.SET_EXPIRED_PLANT_COUNT = (state, data) => {
  state.totalExpiredPlantCount = data;
};

lib.SET_RENEW_PLANT_COUNT = (state, data) => {
  state.totalRenewPlantCount = data;
};

lib.SET_PLANT_NEAR_EXPIRY_COUNT = (state, data) => {
  state.aboutToExpireCount = data;
};

lib.SET_PLANT_DATA = (state, data) => {
  state.plantData = data;
};

lib.SET_MINI_NAV = (state, status) => {
  state.miniNav = status;
};

lib.SET_SHOW_SNACKBAR = (state, payload) => {
  state.showSnackBar = payload;
};

lib.SET_SNACKBAR_CONTENT = (state, { icon, header, message }) => {
  const iconMap = {
    success: "logo/success-icons.svg",
    error: "logo/error-icons.svg",
    warning: "logo/warning-icons.svg",
    notification: "logo/notification-icons.svg",
  };

  state.snackBar.icon = `${iconMap[icon]}`;
  state.snackBar.header = header || "";
  state.snackBar.message = message;
};

lib.SET_SHOW_DIALOG = (state, payload) => {
  state.showDialog = payload;
};

lib.SET_DIALOG_DATA = (state, { ref, icon, header, contents, actions }) => {
  const iconMap = {
    success: "loudspeaker.svg",
    error: "loudspeaker.svg",
    warning: "loudspeaker.svg",
    save: "diskette.svg",
    notification: "loudspeaker.svg",
  };

  state.dialog.ref = ref;
  state.dialog.icon = `${iconMap[icon]}`;
  state.dialog.header = header;
  state.dialog.contents = contents;
  state.dialog.actions = actions;
};

lib.SET_PROGRESS_BAR = (state, payload) => {
  state.isProgress = payload;
};

lib.SET_MINI_NAV = (state, status) => {
  state.miniNav = status;
};

lib.SET_ID_LIST = (state, payload) => {
  Vue.set(state.alteredFilterValues, payload.name, payload.data);
};

lib.SET_LATEST_NOTIFICATION_VIEW_TIMESTAMP = (state, payload) => {
  state.userData.lastNotificationViewed = payload;
};

export default lib;
